export default {
  name: 'Reglament',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    onIntersect: function onIntersect(e) {
      if (e[0].intersectionRatio > 0) {
        this.$emit('enableButton');
      }
    }
  }
};